module.exports = __webpack_public_path__ + "static/media/file-mp4.525abbc7.svg";